import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Game from './game';

ReactDOM.render(
    <Game />,
  document.getElementById('root')
);
